import React from 'react';
import { Grid, MenuItem, Typography, Hidden, TextField } from '@mui/material';

const timeValuesArray = [
    '6:00 am',
    '6:30 am',
    '7:00 am',
    '7:30 am',
    '8:00 am',
    '8:30 am',
    '9:00 am',
    '9:30 am',
    '10:00 am',
    '10:30 am',
    '11:00 am',
    '11:30 am',
    '12:00 pm',
    '12:30 pm',
    '1:00 pm',
    '1:30 pm',
    '2:00 pm',
    '2:30 pm',
    '3:00 pm',
    '3:30 pm',
    '4:00 pm',
    '4:30 pm',
    '5:00 pm',
    '5:30 pm',
    '6:00 pm',
    '6:30 pm',
    '7:00 pm',
    '7:30 pm',
    '8:00 pm',
];

/**
 * Component for selecting time
 *
 * @Component TimeDropDown
 * @param {object} props props
 * @param {string} props.id
 * @param {string} props.Title
 * @param {string} props.defaultTime
 * @param {boolean} props.error
 * @param {string} props.errorText
 * @param {function} props.handleTimeChange
 * @returns TimeDropDown
 */
export const TimeDropDown = props => {
    return (
        <Grid
            container
            xs={12}
            sx={{
                marginTop: 1,
                marginBottom: 1,
                justifyContent: props.center ? 'center' : 'initial',
                alignItems: props.center ? 'center' : 'initial',
            }}
        >
            <Hidden only={['xs']}>
                <Grid item xs={12} sm={3} md={5}>
                    <Typography variant="h6">{props.title}:</Typography>
                </Grid>
            </Hidden>
            <Grid item xs={12} sm={6} md={5}>
                {typeof props.defaultTime !== 'undefined' && (
                    <TextField
                        select
                        id={props.id}
                        label={props.title}
                        variant="outlined"
                        defaultValue={props.defaultTime}
                        onChange={props.handleTimeChange}
                        sx={{ width: '100%' }}
                        error={props.error}
                        helperText={props.error ? props.errorText : ''}
                    >
                        {timeValuesArray.map((time, index) => {
                            return (
                                <MenuItem key={index} id={index} value={time}>
                                    {time}
                                </MenuItem>
                            );
                        })}
                    </TextField>
                )}
            </Grid>
        </Grid>
    );
};

export default TimeDropDown;
